import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/store';
import { LaunchpadAdapter } from './launchpad.adapter';

export const launchpadSelect = (state: RootState) => state.features.launchpads.launchpad;

export const launchpadSelectors = LaunchpadAdapter.getSelectors();

export const selectLaunchpad = createSelector(
    launchpadSelect,
    (state) => launchpadSelectors.selectAll(state)
);

export const selectLaunchpadsEntities = createSelector(
    launchpadSelect,
    (state) => launchpadSelectors.selectEntities(state)
);

export const selectLaunchpads = createSelector(launchpadSelect, (state) =>
    launchpadSelectors.selectAll(state)
);
